<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.create')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-form @submit.prevent="onSubmit" class="av-tooltip">
            <b-form-group :label="`${$t('pages.deliveryTerms.city')} (EN)`">
              <b-form-input type="text" v-model="$v.createForm.cityEn.$model" :state="!$v.createForm.cityEn.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.cityEn.required">
                {{ $t('formErrors.enterCity') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('pages.deliveryTerms.city')} (RU)`">
              <b-form-input type="text" v-model="$v.createForm.cityRu.$model" :state="!$v.createForm.cityRu.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.cityRu.required">
                {{ $t('formErrors.enterCity') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('pages.deliveryTerms.term')} (EN)`">
              <b-form-input type="text" v-model="$v.createForm.termEn.$model" :state="!$v.createForm.termEn.$error" />

              <b-form-invalid-feedback v-if="!$v.createForm.termEn.required">
                {{ $t('formErrors.enterTerm') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('pages.deliveryTerms.term')} (RU)`">
              <b-form-input type="text" v-model="$v.createForm.termRu.$model" :state="!$v.createForm.termRu.$error" />

              <b-form-invalid-feedback v-if="!$v.createForm.termRu.required">
                {{ $t('formErrors.enterTerm') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="$t('pages.deliveryTerms.minPrice')">
              <b-form-input
                type="text"
                v-model="$v.createForm.minPrice.$model"
                :state="!$v.createForm.minPrice.$error"
              />

              <b-form-invalid-feedback v-if="!$v.createForm.minPrice.required">
                {{ $t('formErrors.enterMinPrice') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="$t('pages.deliveryTerms.price')">
              <b-form-input type="text" v-model="$v.createForm.price.$model" :state="!$v.createForm.price.$error" />

              <b-form-invalid-feedback v-if="!$v.createForm.price.required">
                {{ $t('formErrors.enterPrice') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-button
              type="submit"
              variant="primary"
              :disabled="isLoading"
              :class="{
                'btn-multiple-state mt-2': true,
                'show-spinner': isLoading
              }"
            >
              <span class="spinner d-inline-block">
                <span class="bounce1"></span>
                <span class="bounce2"></span>
                <span class="bounce3"></span>
              </span>
              <span class="label">
                {{ $t('buttons.save') }}
              </span>
            </b-button>
          </b-form>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
const { required } = require('vuelidate/lib/validators')

export default {
  data: () => ({
    isLoading: false,
    createForm: {
      cityEn: '',
      cityRu: '',
      termEn: '',
      termRu: '',
      minPrice: null,
      price: null
    }
  }),
  validations: {
    createForm: {
      cityEn: { required },
      cityRu: { required },
      termEn: { required },
      termRu: { required },
      minPrice: { required },
      price: { required }
    }
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 2000, permanent: false })
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          city_en: this.createForm.cityEn,
          city_ru: this.createForm.cityRu,
          term_en: this.createForm.termEn,
          term_ru: this.createForm.termRu,
          min_price: this.createForm.minPrice,
          price: this.createForm.price
        }

        this.$store.dispatch('deliveryTerms/createDeliveryTerm', {
          payload,
          vm: this
        })
      }
    }
  }
}
</script>
